module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.scss
// module id = ./src/app/footer/footer.component.scss
// module chunks = main